const HelperText = (props) => {
  const { color = '#1334C9', fontStyle = 'italic', className = '', children } = props

  return (
    <p
      className={className}
      style={{ color: color, fontStyle: fontStyle, }}>
      {children}
    </p>
  )
}

export default HelperText